import React from "react";

const Select = ({ element }) => {
  if (!element) {
    return <div className="builder_error">Error: Element is undefined.</div>;
  }

  const { placeholder = "Select an option", data } = element;
  const values = Array.isArray(data?.values) ? data.values : [];

  return (
    <div>
      <div className="builder_dropdown_outer">
        <select className="builder_input" defaultValue="">
          <option disabled value="">
            {placeholder}
          </option>
          {values.map((option) => (
            <option key={option.value ?? option.label} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default Select;
